import { Logger } from '@sitecore-search/common';
import { findSelectedFacetValueIndex } from '../../utils/index.js';
class RangeRemoveFilterReducer {
    process(selectedFacets, payload) {
        return selectedFacets.filter((item) => item.facetId !== payload.facetId);
    }
}
class ValueIdRemoveFilterReducer {
    process(selectedFacets, payload) {
        const indexToRemove = findSelectedFacetValueIndex(selectedFacets, payload.facetId, payload.facetValueId);
        return selectedFacets.filter((_, index) => index !== indexToRemove);
    }
}
class TextRemoveFilterReducer {
    process(selectedFacets, payload, _) {
        const { facetId, facetValueText } = payload;
        const indexToRemove = selectedFacets.findIndex((item) => {
            const itemToCompare = item;
            return itemToCompare.facetId === facetId && itemToCompare.facetValueText === facetValueText;
        });
        return selectedFacets.filter((_, index) => index !== indexToRemove);
    }
}
const RemoveFilterReducers = {
    valueId: new ValueIdRemoveFilterReducer(),
    range: new RangeRemoveFilterReducer(),
    text: new TextRemoveFilterReducer(),
};
const removeFilterReducer = (state, payload) => {
    const { selectedFacets = [], response } = state;
    const { type } = payload;
    const currentFacetReducer = RemoveFilterReducers[type];
    if (currentFacetReducer) {
        return { ...state, page: 1, selectedFacets: currentFacetReducer.process(selectedFacets, payload, response) };
    }
    Logger.warn(`${type} has not a valid reducer for REMOVE_FILTER action. No reduce transformation applied.`);
    return { ...state, page: 1 };
};
export default removeFilterReducer;
